import moment from 'moment';
export const parseDateType = (date: string, dateFormat: string) => {
    return moment(date).format(dateFormat);
}

export const formatDateToHourAndMinutes = (value: string)=>{
    const date = value.split('T');
    if(date.length > 1)
        return date[1].substring(0,5);
    else
        return value;
}

export const formatAttachmentLastModifiedForDisplay = (value: Date | string) => {
    const parsed = moment(value);

    if (!parsed.isValid()) {
        return '';
    }

    return parsed.utc().format("YYYY-MM-DDTHH:mm:ssZ");
}
